import React, { FC } from 'react'
import ReactDOM from 'react-dom'

interface CancelConfirmationModalProps {
  isOpen: boolean
  onConfirm: () => void
  onCancel: () => void
}

export const CancelConfirmationModal: FC<CancelConfirmationModalProps> = ({
  isOpen,
  onConfirm,
  onCancel,
}) => {
  if (!isOpen) return null

  return ReactDOM.createPortal(
    <div
      className="fixed inset-0 bg-black/60 backdrop-blur-sm flex items-center justify-center p-4"
      style={{ zIndex: 10000 }}
      onClick={onCancel}
    >
      <div
        className="bg-white rounded-xl shadow-2xl max-w-md w-full overflow-hidden"
        onClick={(e) => e.stopPropagation()}
      >
        {/* Header */}
        <div className="px-6 py-4 border-b border-primary-outline">
          <h3 className="text-lg font-semibold text-primary-text">Cancel Meeting Creation?</h3>
        </div>

        {/* Content */}
        <div className="px-6 py-4">
          <p className="text-sm text-silver-light">
            Are you sure you want to cancel? All information will be lost.
          </p>
        </div>

        {/* Footer */}
        <div className="px-6 py-4 bg-background-light border-t border-primary-outline flex justify-end gap-3">
          <button
            onClick={onCancel}
            className="px-4 py-2 border border-primary-outline text-primary-text rounded-md hover:bg-background-hover transition-colors text-sm font-medium"
          >
            Keep Editing
          </button>
          <button
            onClick={onConfirm}
            className="px-4 py-2 bg-primary-error text-white rounded-md hover:opacity-90 transition-colors text-sm font-medium"
          >
            Yes, Cancel
          </button>
        </div>
      </div>
    </div>,
    document.body
  )
}
